import { render, staticRenderFns } from "./SectionModal.vue?vue&type=template&id=4ece7903&scoped=true"
import script from "./SectionModal.vue?vue&type=script&lang=js"
export * from "./SectionModal.vue?vue&type=script&lang=js"
import style0 from "./SectionModal.vue?vue&type=style&index=0&id=4ece7903&prod&lang=scss"
import style1 from "./SectionModal.vue?vue&type=style&index=1&id=4ece7903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece7903",
  null
  
)

export default component.exports